module.exports = __webpack_public_path__ + "images/blue-calendar-8d7b6ec8.svg";